module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/mastercard@2x-8af5cfbf1981b0c99ccbfee7829ad393.png";